(function () {
  var loc = window.location;
  var drop = ['currency', 'country', 'locale', 'language'];
  var search = '';

  if (loc.search.length > 1) {
    var kept = [];
    var parts = loc.search.slice(1).split('&');
    for (var p = 0; p < parts.length; p++) {
      if (!parts[p]) continue;
      var key = decodeURIComponent(parts[p].split('=')[0]).toLowerCase();
      if (drop.indexOf(key) === -1) kept.push(parts[p]);
    }
    if (kept.length) search = '?' + kept.join('&');
  }

  var here = loc.pathname + search;

  if (loc.pathname === '/404') return;
  if (here.charAt(0) !== '/' || here.charAt(1) === '/') return;

  var forms = document.querySelectorAll('form[action="/localization"]');

  for (var i = 0; i < forms.length; i++) {
    var inputs = forms[i].querySelectorAll('input[name="return_to"]');
    for (var j = 0; j < inputs.length; j++) {
      inputs[j].value = here;
    }
  }
})();
